import { initializeSiteSettings, updateSiteSettings as updateSiteSettingsBase } from '@hb/react'
import { SiteSettings } from '@hb/shared'

export const getLocalStorage = (key: string) => {
  const item = localStorage.getItem(key)
  return item ? JSON.parse(item) : null
}

export const setLocalStorage = (key: string, value: any) => {
  localStorage.setItem(key, JSON.stringify(value))
}

export const getHBDeviceId = (): string => {
  const deviceId = getLocalStorage('hb_device_id')
  if (deviceId) return deviceId
  const newDeviceId = crypto.randomUUID()
  setLocalStorage('hb_device_id', newDeviceId)
  return newDeviceId
}

initializeSiteSettings({
  nativeDateInputOverride: getLocalStorage('nativeDateInputOverride') === true,
})

export const updateSiteSettings = (key: keyof SiteSettings, value: any) => {
  setLocalStorage(key, value)
  updateSiteSettingsBase(key, value)
}
